import { Check, Sparkles, Store } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

// Tags / features in the visitor's language (French originals while the translation is pending).
export const useMinisiteTexts = (app) => {
  const { lang } = useI18n();
  const m = app.minisite || {};
  const tr = (m.i18n || {})[lang] || {};
  const pick = (key) => (tr[key]?.length === (m[key === "tags" ? "business_tags" : "features"] || []).length ? tr[key] : m[key === "tags" ? "business_tags" : "features"]) || [];
  return { tags: pick("tags"), features: pick("features") };
};

export const MinisiteBadge = ({ testId, thirdParty = false }) => {
  const { t } = useI18n();
  return (
    <span className="inline-flex max-w-full items-start gap-1.5 rounded-full border border-emerald-400/60 bg-emerald-500/10 px-3 py-1 text-xs font-semibold text-emerald-100" data-testid={testId}>
      <Sparkles className="mt-0.5 h-3.5 w-3.5 shrink-0" /> <span className="min-w-0 break-words">{t(thirdParty ? "mini.chip.minisite" : "mini.badge")}</span>
    </span>
  );
};

export const MinisiteTags = ({ tags, testId }) =>
  tags.length ? (
    <ul className="flex flex-wrap gap-1.5" data-testid={testId}>
      {tags.map((x, i) => (
        <li key={i} className="inline-flex max-w-full items-center gap-1 break-words rounded-full border border-[rgba(245,197,66,0.3)] px-2.5 py-0.5 text-xs text-[var(--gold-bright)]">
          <Store className="h-3 w-3 shrink-0" /> <span className="min-w-0 [overflow-wrap:anywhere]">{x}</span>
        </li>
      ))}
    </ul>
  ) : null;

export const MinisiteInfo = ({ app }) => {
  const { t } = useI18n();
  const { tags, features } = useMinisiteTexts(app);
  return (
    <div className="mt-6 min-w-0 space-y-4" data-testid="app-detail-minisite">
      <MinisiteBadge thirdParty={!!app.developer} testId="app-detail-minisite-badge" />
      {tags.length > 0 && (
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wider text-neutral-500">{t("mini.forWho")}</p>
          <MinisiteTags tags={tags} testId="app-detail-minisite-tags" />
        </div>
      )}
      {features.length > 0 && (
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wider text-neutral-500">{t("mini.features")}</p>
          <ul className="grid gap-2 sm:grid-cols-2" data-testid="app-detail-minisite-features">
            {features.map((f, i) => (
              <li key={i} className="flex min-w-0 items-start gap-2 text-sm text-neutral-200">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-300" /> <span className="min-w-0 [overflow-wrap:anywhere]">{f}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
